var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.861 6.155a.5.5 0 0 1-.015.706l-10.462 10a.5.5 0 0 1-.691 0l-5.538-5.294a.5.5 0 1 1 .69-.723l5.193 4.964 10.116-9.67a.5.5 0 0 1 .707.017Z",
  fill: "currentColor"
})));
export { SvgCheck as ReactComponent };
export default __webpack_public_path__ + "a09a56100ce08509caf381853883ccae.svg";